export const TranslationsNB = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "Bestill online",
        cart: "Handlekurv",
        open_24: "24 timer",
        closed: "Stengt",
        free: "GRATIS",
        something_went_wrong: "noe gikk galt",
        try_again: "prøv igjen",
    },
    constants: {
        calendar: {
            days: {
                monday: "Mandag",
                tuesday: "Tirsdag",
                wednesday: "Onsdag",
                thursday: "Torsdag",
                friday: "Fredag",
                saturday: "Lørdag",
                sunday: "Søndag",
            },
        },
        services: {
            pickup: "Hent selv",
            delivery: "Levering",
            dine_in: "Spis i restauranten",
            table_booking: "Bestill bord",
        },
        payment: {
            method: {
                cash: "Kontant",
                card: "Kort",
                stripe: "Kredittkort",
                paypal: "PayPal",
                cardconnect: "Kredittkort",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Custom",
            },
            backend_method: {
                cash: "Kontant",
                card: "Kort",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                cardconnect: "CardConnect",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Custom",
            },
            status: {
                success: "Godkjent",
                pending: "Venter",
                error: "Feil",
                refunded: "Refundert",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "Fjern",
                drop_here: "dra filene dine hit eller klikk for å velge",
                accepts: "Godtar {{fileTypes}} filer",
                errors: {
                    max_files: "Maks {{number}} tillatt",
                    max_size: "Maks filstørrelse {{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "Restauranten er stengt for øyeblikket og ordrer med øyeblikkelig levering kan ikke mottas. Du kan prøve igjen senere eller velge en senere dato.",
            },
            buttons: {
                order: {
                    book_order: "Bestill bord / Bestill online",
                    order_online: "Bestill online",
                    book_table: "Reserver nord",
                    order: "Bestill",
                    book: "Reserver",
                    cart: "Handlekurv",
                    restart: "Start på nytt",
                    closed: "Stengt",
                    not_accepting: "Godtar ikke bestillinger",
                },
            },
        },
        modals: {
            auth: {
                login: "Logg inn",
                register: "Registrer",
                register_commence: "Fortsett",
                register_complete: "Opprett konto",
                register_confirmation_sent: "En bekreftelseskode har blitt sent til e-post adressen din. Vennligst skriv inn koden for å fortsette.",
                register_confirmation_resent: "Bekreftelseskoden har blitt sendt på nytt, sjekk søppelmappen din for å starte på nytt.",
                register_restart: "Start på nytt",
                register_resend_code: "Send koden på nytt",
                login_placeholder: "E-post",
                password_placeholder: "Passord",
                confirm_password_placeholder: "Bekreft Password",
                confirmation_code_placeholder: "E-post bekreftelseskode",
                accept_terms: "Godta betingelsene",
                accept_terms_view: "Les",
                login_facebook: "Logg inn med Facebook",
                login_google: "Logg inn med Google",
                benefits: "Logg inn eller opprett en konto for å lagre bestillingene dine.",
                logged_in: "Logget inn",
                logged_out: "Logget ut",
                password_reset: {
                    init_button: "Send e-post for å tilbakestille passordet.",
                    init_success: "En link for å tilbakestille passordet er sendt din e-postadresse.",
                    complete_button: "Tilbakestill passordet",
                    complete_success: "Passordet er tilbakestilt, logg inn med ditt nye passord.",
                    forgot_password_text: "Glemt passordet ditt?",
                    forgot_password_link: "Tilbakestill passord",
                    remember_password_text: "Husker du passrodet ditt? ",
                    remember_password_link: "Tilbake",
                    invalid_title: "Tilbakestilling av passord er feil.",
                    invalid_description: "Denne linken for tilbakestilling av passord er ikke gyldig, be om et nytt i stedet",
                    invalid_link: "Gå til innlogging",
                    title: "Tilbakestilling av passord",
                    description: "Velg et nytt passord for kontoen din",
                },
                error_generic: "Noe gikk galt, vennligst prøv igjen eller ta kontakt.",
                error_accept_terms: "Du må godta betingelsene",
                error_password_length: "Minimum 6 bokstaver i passordet",
                error_social: "Noe gikk galt, prøv igjen eller kontakt oss",
                error_confirmation_code: "Ugyldig bekreftelseskode",
                error_invalid_code: "Ugyldig bekreftelseskode",
                error_exists: "Brukeren finnes allerede",
                error_invalid_email_pass: "Feil e-postadresse eller passord",
                error_password_no_match: "Passordene er ikke like",
                error_user_not_found: "Ingen bruker med den e-postadressen",
                error_invalid_email: "Ugyldig e-postadresse",
                error_invalid_reset_token: "Ugyldig link for tilbakestilling, prøv en annen",
            },
            booking: {
                form: {
                    name: "Navn",
                    email: "E-postadresse",
                    phone: "Mobil",
                    number_of_people: "Antall personer",
                    number_of_people_max: "Antall personer ({{max_people}} Max)",
                    number_of_people_min: "Antall personer ({{min_people}} Min)",
                    number_of_people_max_min: "Antall personer (Between {{min_people}} to {{max_people}})",
                    notes: "Kommentarer / Spesielle ønsker",
                    submit: "Send forespørselen",
                    email_optional: "(valgfritt)",
                    date: "Dato",
                    duration: "Varighet",
                    seating: "Ledige tidspunkt",
                    number_of_guests: "Antall gjester",
                    notes_placeholder: "Allergier, anledning, plassønske",
                    reserving: "Reserverer...",
                    reserve_table: "Reserver bord",
                    please_choose_a_date_and_time: "Velg en dato og et tidspunkt.",
                    invalid_people: "Antall personer må være mellom {{min}} og {{max}}.",
                    party_size_max_fallback: "det tillatte maksimumet",
                    loading_available_times: "Laster ledige tidspunkt…",
                    select_a_date_to_see_available_times: "Velg en dato for å se ledige tidspunkt.",
                    no_times_available_for_this_date: "Ingen ledige tidspunkt på denne datoen. Velg en annen dag.",
                    shift: "Vakt",
                    service_times: "Servicetider",
                    new_shift: "Ny vakt",
                    time: "tidspunkt",
                    times: "tidspunkt",
                    unavailable: "Ikke ledig",
                    available: "Ledig",
                    required_name: "Skriv inn navnet ditt.",
                    required_phone: "Skriv inn telefonnummeret ditt.",
                    required_email: "Skriv inn e-postadressen din.",
                    invalid_email: "Skriv inn en gyldig e-postadresse.",
                    required_terms: "Godta vilkårene før du reserverer.",
                    missing_custom_fields: "Svar på alle obligatoriske spørsmål.",
                    reservation_is_unavailable: "Reservasjon er ikke tilgjengelig.",
                    please_contact_the_restaurant_directly: "Kontakt restauranten direkte.",
                    almost_done: "Nesten ferdig",
                    your_details: "Dine opplysninger",
                    tell_us_who_s_coming: "Fortell oss hvem som kommer, så vi kan bekrefte reservasjonen din.",
                    book_your_table: "Reserver bordet ditt",
                    choose_a_time_that_works_for_you: "Velg et tidspunkt som passer deg.",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "Send reservasjonsforespørselen din, så tar restauranten seg av resten.",
                    select_date: "Velg dato",
                    standard: "Standard",
                    minutes: "minutter",
                    next: "Neste →",
                    back: "← Tilbake",
                    accept_terms: "Jeg godtar vilkårene.",
                    info_1: "Du vil motta en ny e-post når bestillingen din er godtatt",
                },
                errors: {
                    not_found: "Bestllingen eksisterer ikke. Den ble muligens slettet",
                    generic: "Noe gikk galt, last inn siden på nytt eller ta kontakt",
                    something_went_wrong: "Soe gikk galt",
                    accept_terms: "Vennligst godta betingelsene",
                    required_phone: "Vennligst skriv inn mobilnummeret ditt",
                    required_email: "Vennligst skriv inn e-postadressen din",
                    required_name: "Vennligst skriv inn navnet ditt",
                    invalid_email: "Vennligst skriv inn en gyldig e-postadresse",
                    invalid_phone: "Vennligst skriv inn et  gyldig telefonnummer",
                    invalid_people: "Ugyldig antall personer",
                    booking_capacity_threshold: "Vi er fullbooket på dette tidspunktet. Prøv et annet tidspunkt.",
                    slot_unavailable: "Vi er fullbooket for dette antallet personer. Prøv et annet tidspunkt.",
                    booking_date_paused: "Reservasjoner er satt på pause for denne datoen. Velg en annen dag.",
                    invalid_table_assignment: "De bordene har ikke plass til følget ditt. Velg et annet tidspunkt.",
                    exceeded_order_limit: "For mange reservasjonsforespørsler. Prøv igjen senere.",
                    validation_failed_recaptcha_v3: "Uvanlig trafikk oppdaget. Bruker du VPN? Fullfør kontrollen ovenfor og prøv igjen.",
                    validation_failed_recaptcha_v2: "Reservasjonen kunne ikke startes. Prøv igjen eller bruk en annen metode. Hvis du bruker VPN, prøv å slå det av først.",
                    booking_already_exists: "Denne reservasjonen er allerede sendt. Sjekk e-posten din eller åpne reservasjonskoblingen din.",
                    invalid_party_size: "Velg et gyldig antall personer.",
                    invalid_request: "Ugyldig forespørsel. Oppdater siden og prøv igjen.",
                    table_booking_unavailable: "Bordreservasjon er ikke tilgjengelig.",
                },
            },
            cart: {
                title: "Handlekurv",
                proceed_to_checkout: "Gå til bestilling",
                edit_dish: "Endre",
                remove_dish: "Fjern",
                no_items_1: "Ingen varer i handlekurven",
                no_items_2: "Legg til noe før du går videre",
                free_delivery_notice: "Gratis levering for bestillinger over {{value, currency}}",
                errors: {
                    min_order_promo: "Minimum handlekurvverdi  {{value, currency}} er påkrevd før rabattkoden kan bli lagt til",
                    min_order_delivery: "Minimum handlekurvverdi er {{value, currency}} for levering",
                },
                promo: {
                    heading: "Rabattkode",
                    placeholder: "Skriv inn rabattkoden din",
                    add: "Legg til kode",
                    title: "Rabattkoden {{name}} er lagt til handlekurven",
                    fixed_discount: "{{value, currency}} rabatt",
                    percent_discount: "{{value}}% rabatt",
                    added_to_cart: "Rabatten er lagt til handlekurven",
                    errors: {
                        not_found: "Rabattkoden ikke funnet",
                        disabled: "Rabattkoden er ikke aktivert",
                        not_available: "Rabattkoden er ikke i bruk for øyeblikket",
                        logged_in_only: "Du må være innlogget for å bruke denne rabattkoden",
                        already_used: "Du har allerede brukt denne rabattkoden",
                        invalid: "Denne rabattkoden er ikke lenger gyldig",
                        invalid_service: "Denne rabattkoden er ikke gyldig for den valgte tjenesten",
                        later_only: "Bare gyldig for forhåndsbestillinger",
                        now_only: "Gyldig bare for bestikllinger med levering med en gang, ikke for forhåndsbestillinger",
                        generic: "Oj, noe gikk galt og har blitt loggført",
                        dishes_required_multi: "Denne rabattkoden blir bare aktivert når spesielle retter er lagt til handlekurven",
                        dishes_required_single: "Denne rabattkoden blir bare aktivert for '{{dish}}'",
                    },
                },
                tip: {
                    title: "Tips",
                    placeholder: "Legg til tips",
                },
            },
            checkout: {
                title: "Kassen",
                subtitle: "Beskreft bestillingesdetaljene",
                details: {
                    service: "Tjeneste",
                    due: "Innen",
                    due_now_asap: "Nå / Med en gang",
                    address: "Leveringsadresse",
                    total: "Totalt",
                    table: "Bord",
                    store_location: "Firmaadresse",
                },
                customer: {
                    title: "Kunde",
                    subtitle: "Logg inn for å lagre bestillingen og detaljene",
                    button: "Logg inn",
                    name: "Navn",
                    email: "E-postadresse",
                    phone: "Telefon",
                    phone_important: "Telefonnummer (Viktig)",
                    notes: "Bestillingsnotat",
                    delivery_notes: "Leveringsanvisninger / Ordrenotater",
                    optional: "valgfritt"
                },
                payment: {
                    title: "Betalingsmetode",
                },
                accept_terms: "Godta betingelsene",
                accept_terms_view: "Se",
                processing_order: "Fullfører bestillingen",
                warning: {
                    different_payment_currency: "Restaurantens priser er i {{store_currency}} men betalingsmetoden er i {{payment_currency}}",
                    closing_soon: "Stenger snart, bestillinger må være lagt inn innen {{value}} minutter",
                    closed: "bekalger, denea tjenesten er stengt og bestillinger kan ikke mottas",
                    expired: "Vi kan ikke lenger fullføre bestillingen din på dette tidspunktet. Vær vennlig og velg et annet tidspunkt",
                },
                errors: {
                    stripe_generic: "Feil med kredittkort, prøv igjen eller velge en annen betalingsmetode",
                    stripe_loading_fail: "Feil med lasting av betalingsmetoden, prøv igjen",
                    something_went_wrong: "Noe gikk galt",
                    paypal_generic: "Noe gikk galt med PayPal, prøv igjen eller velg en annen betalingsmetode",
                    payment_fail: "Betalingen mislyktes, vennligst prøv igjen eller velg en annen betalingsmetode",
                    payment_cancelled: "Betalingen er kansellert, vennligst prøv igjen eller velg en annen betalingsmetode",
                    payment_error: "Det oppstod en feil under betalingen, prøv igjen eller velg en annen betalingsmetode",
                    payment_declined: "Betalingen din ble ikke godkjent",
                    card_declined: "Kortet ditt ble avvist og betalingen kunne ikke godkjennes",
                    promo_max_uses_exceeded: "Denne kampanjekoden har nådd bruksgrensen og er ikke lenger tilgjengelig.",
                    store_closed: "Restauranten er stengt og tar ikke lenger i mot bestillinger",
                    accept_terms: "Vær vennlig og godta vilkårene",
                    required_payment: "Vær vennlig og velg betalingsmetode",
                    required_phone: "Vær vennlig og skriv inn telefonnummer",
                    required_email: "Vær vennlig og skriv inn skriv inn e-posten din",
                    required_name: "Vær vennlig og skriv inn navn",
                    invalid_email: "Skriv en gyldig e-postadresse",
                    invalid_phone: "Vær vennlig og Vær vennlig og skriv et gyldig telefonnummer",
                    invalid_cc_number: "Kredittkortnummeret ditt er ugyldig",
                    retry_cc_number: "Noe gikk galt, skriv inn kredittkortnummeret ditt på nytt og prøv igjen",
                    closed: "Butikken er stengt og kan ikke motta bestillinger",
                    promo_login_required: "Du må være logget inn for å bruke denne rabattkoden",
                    promo_used: "Du har allerede brukt denne rabattkoden",
                },
                button: {
                    continue: "Fortsett til betaling",
                    place_order: "Bestill",
                },
            },
            customer: {
                age_v: {
                    title: "Alderskontroll",
                    required_for_items: "PÅkrevd for å bestille bestemte varer",
                    min_age: "Minimum alder: {{age}} år",
                    est_time: "Beregnet gdokjenningtid: {{time}} timer",
                    upload_description: "Upload your ID below for verification. You will be notified via e-mail once verified. Upload up to 2 images with a maximum size of 2 MB each",
                    pending_description_1: "Thank you for submitting your documents. You will be notified via e-mail when you are approved",
                    pending_description_2: "Refresh the page to update your verification status. Estimated verification time is {{time}} hours",
                    approved_description: "Your account has been verified and you can order from restricted menus",
                    rejected_description: "Your ID has been rejected. If you wish to try again, please re-upload your ID",
                    upload: "Upload",
                    reupload: "Re-Upload Documents",
                    go_back: "Go Back",
                    view_document: "View Document {{number}}",
                    status: {
                        unverified: "Un-verified",
                        pending: "Waiting For Approval",
                        approved: "Successfully Verified",
                        rejected: "Rejected",
                    },
                },
                headings: {
                    sessions: "Besøk",
                    orders: "Bestillinger",
                    spend: "Bruk",
                    order_history: "Bestillingshistorikk",
                    loyalty_points: "Lojalitetspoeng",
                },
            },
            custom_payment: {
                title: "{{name}} Betalingsform",
                description: "Du har kommet til vårt nettbaserte betalingsekjema. Vennligst fullfør feltene for å gjennomføre en betaling. Hvis beløpet ikke er skrevet inn, vil detaljene dine bli lagret men du vil ikke bli belastet.",
                disabled: "Denne online betalingssiden har ikke blitt konfigurert korrekt. Vær vennlig ig kontakt sideadministrator.",
                success: "Betalingen fin ble godkjent og detaljene din er lagret. Tusen takk.",
                back: "Tilbake til startsiden",
                fields: {
                    name: "Navn",
                    email: "E-postadresse",
                    reference: "Betalingsreferanse",
                    amount: "Beløp ($)",
                    name_on_card: "Navn på kort",
                    submit: "Send betaling",
                },
                warning: {
                    currency: "Merk: Betalingen er i {{actual}}, ikke {{default}}",
                },
                errors: {
                    generic: "Noe gikk galt, prøv igjen eller kontakt oss",
                    stripe_generic: "Feil med betalingskort, last inn siden på nytt og prøv igjen",
                    payment_fail: "Betalingen mislyktes, vennligst prøv igjen eller velg en annen betalingsmetode",
                    payment_cancelled: "Betalingen ble kansellert, vennligst prøv igjen eller velg en annen betalingsmetode",
                    payment_error: "B, vennligst prøv igjen eller velg en annen betalingsmetode",
                    payment_declined: "Your payment method was declined",
                    card_declined: "Your card was declined and payment couldn't be processed",
                    promo_max_uses_exceeded: "Denne kampanjekoden har nådd bruksgrensen og er ikke lenger tilgjengelig.",
                },
            },
            dish: {
                add: "Add To Cart",
                edit: "Update Item",
                notes: "Viktige beskjeder",
                ingredients: {
                    title: "Ingredients",
                    uncheck_remove: "Un-check to remove",
                },
                ingredients_title: "Ingredients",
                combo: {
                    choose_dish: "Choose A Dish",
                },
                option_sets: {
                    conditions: {
                        select_one: "Select one (Required)",
                        select_one_optional: "Select one (Optional)",
                        select_between: "Select between {{min}} - {{max}} (Required)",
                        select_at_least: "Select at least {{qty}} (Required)",
                        select_up_to: "Select up to {{qty}} (Optional)",
                        select_multiple: "Select multiple (Optional)",
                        free_amount: "First {{qty}} Free / {{selected}} Chosen",
                    },
                },
                error: "Please correct any options marked in red",
                added_to_cart: "Item Added To Cart",
            },
            map: {
                zone_fee: "Delivery Fee",
                view_in_google: "View In Google Maps",
            },
            portal_go_back: {
                title: "Go Back To Restaurant Search?",
                description: "Any items in your cart will be lost",
                cancel: "Cancel",
                proceed: "Go Back",
            },
            order: {
                config: {
                    services: {
                        title: "Choose A Service",
                        table_booking: "Bestill bord",
                    },
                    address_custom: {
                        input_placeholder: "Enter your address",
                    },
                    address: {
                        input_placeholder: "Find Your Delivery Address",
                        extras_placeholder: "Unit number, building name, delivery instructions, etc...",
                        search_placeholder: "Search For Your Address",
                        not_found: "Delivery address not found or valid, try again",
                        not_delivering: "We are currently not delivering to this address",
                        not_in_range: "Your address is not in range of our store location",
                        not_in_zone: "Your address is not within an active delivery zone",
                    },
                    datetime: {
                        title: "When Would You Like Your Order",
                        due_now: "Now",
                        due_later: "Later",
                        service_not_available: "Sorry, we are currently not accepting orders for {{service}}",
                        currently_closed: "{{service}} currently closed but you can order for later",
                        due_unavailable: "Unavailable",
                        due_closed: "Closed",
                        select_date: "Select Date",
                        select_time: "Select Time",
                        select_order_date: "Select Your Order Date",
                        select_order_time: "Select Your Order Time",
                        select_booking_date: "Select Your Booking Date",
                        select_booking_time: "Select Your Booking Time",
                        no_times_available: "No times available to choose from",
                        date_today: "(Today)",
                        date_closed: "(Closed)",
                        date_bookings_paused: "(Reservasjoner på pause)",
                        time_slot_closed: "Closed",
                    },
                    number_of_people: {
                        placeholder: "Number Of People",
                    },
                    table: {
                        select: "Select Table",
                        select_popup_title: "Select Your Table",
                        password: "Table Password",
                        password_warning: "Enter your table password to proceed",
                    },
                    warning: {
                        closed: "Sorry, we are currently closed / not accepting any orders",
                        not_available: "Sorry, we are currently not accepting any orders",
                    },
                    start_button: "Start Order",
                },
                history: {
                    invalid: "Not eligible for re-order as some of the items ordered have been modified or are no longer available",
                },
                reorder: {
                    title: "Quick Re-Order",
                    description: "Easily order the items from your previous orders",
                },
            },
            receipt: {
                errors: {
                    not_found: "Order not found, refresh the page and try again",
                    booking_not_found: "Reservasjonen finnes ikke. Den kan ha blitt slettet",
                    generic: "Something went wrong, refresh the page or contact us",
                },
                connection: {
                    connected: "Real-time updates",
                    connecting: "Real-time updates connecting",
                    disconnected: "Real-time updates disconnected",
                },
            },
            warnings: {
                logout: {
                    pretitle: "Warning",
                    title: "Logout",
                    body: "Logging out will remove any items that have been added to your cart",
                    cancel: "Cancel",
                    proceed: "Proceed",
                },
                order_restart: {
                    warning: "Warning",
                    title: "Change Order Details",
                    body: "Changing your order details will remove the items in your cart as certain dishes may become unavailable",
                    cancel: "Cancel",
                    proceed: "Proceed",
                },
                order_expired: {
                    subtitle: "Important",
                    title: "Order changed to due immediately",
                    description: "The time selected for you order is now not far off. As such your order has been modified to due immediately / ASAP",
                    button: "Ok",
                },
                order_expiring: {
                    subtitle: "Important",
                    title: "Order Deadline Expiring Soon",
                    description: "Your order must be placed before {{time, timeFromTimestamp}} otherwise it no longer be valid",
                    button: "Ok",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "Guest",
                login: "Login",
                login_signup: "Login / Sign Up",
                logout: "Logout",
            },
            menus: {
                info: {
                    no_menus: "There are currently no menus available",
                    restrictions: "Menu Restrictions",
                    not_available: "Menu Unavailable",
                    unavailable: {
                        times: "Menu unavailable, your order requirements don't match below",
                        services: "Menu unavailable, your order requirements don't match below",
                        hours: "Menu unavailable, your order hours not within this menus available hours",
                        pre_order: "Menu unavailable, your order doesn't match the pre-order requirements",
                        age: "Menu unavailable, you must be logged in with a age verified account to order from this menu",
                    },
                    services: {
                        title: "Order Requirements",
                        pickup: "Pickups",
                        delivery: "Deliveries",
                        dine_in: "Dine-Ins",
                    },
                    times: {
                        now: "No pre-orders",
                        later: "Pre-orders only",
                    },
                    hours: {
                        title: "Available Hours",
                    },
                    preorder: {
                        title: "Pre-Order Requirements",
                        days_in_advance: "Must order {{days}} days in advance",
                        cutoff_time: "Last day cut-off time at {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "Age Restricted",
                        approved: "Your account is verified and you can order from this menu",
                        rejected: "Requires age verification to order. Create an account and upload your ID",
                    },
                },
            },
            info: {
                location: {
                    title: "Location",
                    view_map: "View Map",
                    phone: "Phone",
                },
                hours: {
                    title: "Opening Hours",
                    title_special: "Special Opening Hours",
                },
                services: {
                    title: "Services",
                    notes: "Notes",
                    delivery: {
                        ranges: "Delivery Ranges",
                        zones: "Delivery Zones",
                        view_zones: "View Zones On Map",
                        fee: "Delivery Fee",
                        fee_short: 'Fee',
                        fee_varies: "Varies, shown in cart",
                        min_order: "Minimum Order",
                        min_order_short: 'Min. Ord.',
                        no_min_order: "No Minimum Order",
                        free_amount: "Free Delivery Amount",
                    },
                },
            },
            contact: {
                title: "Kontakt oss",
                name: "Navn",
                email: "E-post",
                phone: "Telefonnummer",
                message: "Skriv inn meldingen din...",
                send: "Send melding",
                success: "Meldingen din ble sendt",
                error: "Noe gikk galt, prøv igjen eller senere",
            },
            footer: {
                powered_by: "Powered By",
                terms_and_conditions: "Terms & Conditions",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Booking Receipt',
            details: {
                datetime: 'Booking For',
                number_of_people: 'No. Of People',
                placed: 'Placed',
                updated: 'Last Updated',
                notes: 'Notes',
                name: 'Name',
                email: 'E-Mail',
                phone: 'Phone',
                store_address: 'Store Address',
            },
            status_update: {
                title: 'Booking {{number}} Updated',
                body: 'Your booking status has been updated to {{status}}',
            },
            email_status_update_customer: {
                subject: 'Reservasjon #{{number}} – {{subjectLabel}}',
                body: 'Reservasjonen din #{{number}} hos {{store}} er nå {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Bestilling #{{number}} – {{subjectLabel}}',
        header: 'Oppdatert klokkeslett for ferdig',
        title: 'Oppdatert klokkeslett for ferdig',
        order_number: 'Ordrenummer: {{number}}',
        description: 'Bestillingen din er nå klar kl. {{time}}.',
        order_time_updated_to: 'Tidspunktet for bestillingen din er oppdatert.',
        powered_by: 'Drevet av {{name}}',
        button_text: 'Spor bestilling',
        subject_label: 'Oppdatert klokkeslett for ferdig',
        subject_label_delivery: 'Oppdatert leveringstidspunkt',
        body_ready: 'Bestillingen din er nå klar kl. {{time}}.',
        body_delivery: 'Bestillingen din blir nå levert kl. {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Est. Ready Time',
            est_driver_pickup_time: 'Est. Driver Pickup Time',
            est_delivery_time: 'Est. Delivery Time',
            tab_details: 'Details',
            tab_dishes: 'Dishes',
            details: {
                status: 'Status',
                placed: 'Placed',
                due: 'Due',
                due_asap: 'Now / ASAP',
                last_updated: 'Last Updated',
                total: 'Total',
                type: 'Type',
                table: 'Table',
                number_of_people: 'Number Of People',
                payment_method: 'Payment Method',
                payment_status: 'Payment Status',
                payment_currency: 'Payment Currency',
                notes: 'Notes',
                name: 'Name',
                email: 'E-Mail',
                phone: 'Phone',
                distance: 'Distance',
                driving_time: 'Driving Time',
                delivery_zone: 'Zone',
                delivery_address: 'Delivery Address',
                delivery_tracking: 'Delivery Tracking',
                delivery_tracking_link: 'Real-time tracking link',
                tookan_status: 'Tookan Status',
                tookan_status_failed_book: 'Failed to book delivery',
                tookan_status_failed_update: 'Failed to update booking',
                tookan_status_success: 'Booked for delivery',
                store_address: 'Store Address',
            },
            dishes: {
                headings: {
                    quantity: 'Qty',
                    item: 'Item',
                    price: 'Price',
                },
                notes: 'Notes',
                remove_ingredients: 'Remove Ingredients',
            },
            status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order status has been updated to {{status}}',
            },
            wait_time_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order due time has been updated',
            },
            delivery_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order has been booked for delivery. See real-time tracking link',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "Spor bestilling",
                track_delivery_button_text: "Spor levering",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "Spor bestilling",
                track_delivery_button_text: "Spor levering",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) inc. in price",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "Delivery Fee",
            promo: "Discount: {{name}} ({{value, currency}} + {{percent}}% Off)",
            promo_percent: "Discount: {{name}} ({{percent}}%)",
            promo_fixed: "Discount: {{name}}",
            promo_none: "Discount: {{name}}",
            cart: "Cart",
            tip: "Order tip",
            total: "Total",
        },
        status: {
            unconfirmed: "Un-Confirmed",
            awaiting_payment: "Awaiting Payment",
            confirmed: "Confirmed",
            ready: "Ready",
            on_route: "On Route",
            complete: "Complete",
            cancelled: "Cancelled",
            seated: "Plassert",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "Unavailable",
                },
            },
            dish: {
                no_stock: "Out Of Stock",
                not_available: "Not Available",
            },
        },
    },
};
//# sourceMappingURL=nb.js.map